import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/auth";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const next = search.get("next") || "/admin";

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await axios.post(`${API}/admin/login`, { email, password }, { withCredentials: true });
      navigate(next.startsWith("/") ? next : "/admin", { replace: true });
    } catch (err) {
      setErr(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--cream)] text-[var(--ink)] flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-8">
          <div className="w-9 h-9 rounded-full bg-[var(--ink)] text-[var(--cream)] flex items-center justify-center text-sm font-bold">N</div>
          <div>
            <div className="font-display text-xl leading-none">Nutriora Admin</div>
            <div className="text-[11px] text-[var(--muted)] mt-1 font-mono-caption tracking-[0.2em] uppercase">Milk2Income · Affiliate ops</div>
          </div>
        </div>
        <h1 className="font-display text-2xl mb-6">Sign in</h1>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-2">Email</label>
            <input required type="email" className="input-base" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-2">Password</label>
            <input required type="password" className="input-base" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" />
          </div>
          {err && <div className="p-3 bg-red-50 text-red-700 rounded-lg text-sm" data-testid="admin-login-error">{err}</div>}
          <button disabled={busy} type="submit" className="w-full py-3 rounded-full bg-[var(--marigold)] text-white font-medium" data-testid="admin-login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </div>
      </form>
    </div>
  );
}
